import React, { useRef, useEffect, useState,useContext, useCallback } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import {AppContext} from '../../../Context/AppContext'
import axios from 'axios'
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { format,parseISO } from 'date-fns'


const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({

    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },


    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    grow: {
        flexGrow: 1,
    },
    productListPaper: {

        marginBottom: 50,
    },
    table: {
        maxWidth: '100%'
      }
}));

const materialTheme = createTheme(({
    // set default for now
  }));

const filter = createFilterOptions();

export default function ViewInventorySummary(props) {
    const {companyId} = useContext(AppContext)
    const classes = useStyles();
    const [searchProductTerm, setSearchProductTerm] = useState({name:""})
    const [autoSuggestProducts, setAutoSuggestProducts]  = useState([])
    const [products, setProducts] = useState([])
    const [totalReturnedAmount,setTotalReturnedAmount] = useState(0)
    const [totalItemReturnCount,setTotalItemReturnCount] = useState(0)
    const [principalCompanyId,setPrincipalCompanyId] = useState("200900")
    const [isLoading,setIsLoading] = useState(true)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
    const [inventoryViewingSetting, setInventoryViewingSetting] = useState()

    const elementRef = useRef(null);
    const [, setAppBarWidth] = useState(0);
    const [hasMoreProductToLoad,setHasMoreProductToLoad] = useState(true)
    const [pageNumber,setPageNumber] = useState(1)
    const [loadProducts,setLoadProducts] = useState(true)

    const lastProductElementObserver = useRef()
    const lastProductElement = useCallback(node=>{
      if(isLoading){
          return
      }
      if(lastProductElementObserver.current){
        lastProductElementObserver.current.disconnect()
      }
      lastProductElementObserver.current = new IntersectionObserver(entries=>{
        if(entries[0].isIntersecting && hasMoreProductToLoad){
          
          lastProductElementObserver.current.disconnect()
          setPageNumber(prevPageNumber => prevPageNumber + 1)
          setLoadProducts(true)
        }

      })
      
      if(node){
        lastProductElementObserver.current.observe(node)
      }
    },[isLoading, hasMoreProductToLoad])


    function formatDate(dateString){
        try {
          return format(parseISO(dateString), 'MMMM d,yyyy')
        }catch(err){
          return ""
        }
      }


    const onOrderOrPriceInputOnChange = (product,unit)=>(event)=>{
      
        const productsCopy = [...products]
        const quantity = event.target.value
        unit.returned_quantity = quantity.length <=0 ? 0 : quantity

        product.total_returned_value = computeTotalReturnedAmountPerProduct(product)
        saveOrDeleteLocalStorageTempReturned(product)
        setTotalItemReturnCount(getTotalIteReturnedCount())
        setTotalReturnedAmount(computeOverallTotalReturnedAmount())
       
        setProducts(productsCopy)
  
       
      }

      function computeOverallTotalReturnedAmount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
         const overallTotalAmount = temporaryReturnedProducts.reduce((partialSum,product)=>partialSum + computeTotalReturnedAmountPerProduct(product),0.00).toFixed(2)
         
         return overallTotalAmount
         
      }

    function computeTotalReturnedAmountPerProduct(product){
        const totalInvoiceValue = Number(product.Units.reduce((partialSum,unit)=> 
          {
            const amount = parseFloat(unit.returned_quantity) * unit.price_with_tax
            return partialSum + (isNaN(amount) ? 0 : amount)
  
          },0.00 ))
        return isNaN(totalInvoiceValue) ? 0 : totalInvoiceValue
    }
    
    function saveOrDeleteLocalStorageTempReturned(product){
        const temporaryReturnedString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedString == null){
           localStorage.setItem("temporary_returned_products",JSON.stringify([product]))
           return
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedString)//JSON.parse(localStorage.getItem("temporary_order"))
         const index = temporaryReturnedProducts.findIndex(tempReturnedProduct => tempReturnedProduct.code == product.code && tempReturnedProduct.company_id== product.company_id)
         const totalReturnedAmount = computeTotalReturnedAmountPerProduct(product)
      
         if(index >=0){
           //update
           if(totalReturnedAmount > 0){
            temporaryReturnedProducts.splice(index,1,product) //replace object
    
           }else if(totalReturnedAmount <= 0){
            temporaryReturnedProducts.splice(index,1) //remove object
           }
         
         }else{
           if(totalReturnedAmount > 0){
            temporaryReturnedProducts.push(product)
           }
          
         }
    
         localStorage.setItem("temporary_returned_products",JSON.stringify(temporaryReturnedProducts))
      }
      function getTotalIteReturnedCount(){
        const temporaryReturnedProductsString = localStorage.getItem("temporary_returned_products")
         if(temporaryReturnedProductsString == null){
           return 0
         }
         const temporaryReturnedProducts = JSON.parse(temporaryReturnedProductsString)
    
         const totalOrderedItems = temporaryReturnedProducts.reduce((productWithReturnedPartialCount,product)=>{
           return productWithReturnedPartialCount + product.Units.reduce((partialCount,unit)=>partialCount + (unit.returned_quantity > 0 ? 1 : 0),0)
         },0)
         
         return totalOrderedItems
         
      }

    function autoComplete() {

        return (
            <Autocomplete
                value={searchProductTerm}
                noOptionsText={'No record found'}
                onChange={(event, newValue) => {
                    
                if(newValue==null || newValue.name===""){
                    searchProductTerm.name = ""
                    return
                  }
                  searchProductTerm.name = newValue.name
                  setProducts([])
                  setPageNumber(1)
                  setLoadProducts(true)
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={autoSuggestProducts}
                isOptionEqualToValue={(option, value) =>true}
                getOptionLabel={(option) => {
                    
                        return option.name;
                }}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.name}>
                      {option.name}
                    </li>
                  );
                }}
                style={{ width: '100%', paddingLeft: '8px' }}

                renderInput={(params) => (
                    <TextField 
                    variant='standard'
                    {...params} 
                    InputProps={{ ...params.InputProps, disableUnderline: true }}
                    onChange={(event)=>{
                        setSearchProductTerm({name:event.target.value})
                    }}
                     />
                )}
            />
        );
    }
    function orderValue(unit) {
        return unit.returned_quantity == null ||  unit.returned_quantity <= 0 ? '' : unit.returned_quantity
    }
    function returnProductInput(product, unit) {
        return (
            <Box display="flex" justifyContent="flex-end" >
                <Box p={1} display="flex" justifyContent="center" flexDirection="column">
                    <Typography variant="h6" component="span" style={{ fontWeight: 600, fontSize: "16px" }}>{1000}  <small>{'pcs'}</small></Typography>
                </Box>
                <Box p={1} style={{ maxWidth: "100px" }}>
                    <TextField
                        id="outlined-size-small"
                        variant="outlined"
                        size="small"
                        type="number"
                        value={0}
                        
                    />
                </Box>

            </Box>
        )
    }
    function productLotNumberAndExpiration(product){
     
      if(inventoryViewingSetting == null || inventoryViewingSetting.viewing == 0){
        return ""
      }
       
        return(
          <Grid item style={{ fontWeight: 600, fontSize: "100%",width:'100%'}}>
            <List>
            {
                product.lot_number_and_expiration.map(lot_number_and_expiration => (
                    <React.Fragment key={lot_number_and_expiration.lot_number+lot_number_and_expiration.expiration_date}>
                        <ListItem>
                          Inventory : {Number(lot_number_and_expiration.quantity).toLocaleString(undefined, {minimumFractionDigits:0,maximumFractionDigits:0})}<br/>
                          Lot # : {lot_number_and_expiration.lot_number} <br/>
                          Expiration : {formatDate(lot_number_and_expiration.expiration_date)}<br/>
                        </ListItem>
                        <Divider light />
                    </React.Fragment>
                )
                )
            }
        </List>
        </Grid>
        )

    }
    function search() {
        return (
            <div position="static" style={{ border: ".1rem solid #989898", borderRadius: "4px", margin: '2px' }}>
                <Toolbar variant="dense" style={{ padding: '0' }}>
                    <Box flexGrow={1}>{autoComplete()}</Box>
                    <Box>
                        <IconButton className={classes.margin} size="large" onClick={()=>{
                                setProducts([])
                                setPageNumber(1)
                                setLoadProducts(true)
                            }}>
                            <SearchIcon />
                        </IconButton>
                    </Box>
                </Toolbar>
            </div>
        );
    }
    
    function productLists(){
      return(
        <>
          {
            products.map((product,index)=>(
                (products.length  === index + 1) ?
                (
                  <React.Fragment key={index+product.id+product.name} >
                    <ListItem ref={lastProductElement} key={index+product.id+product.name} divider >
                      {productElement(product)}
                    </ListItem>
                  </React.Fragment>
                 )
                :
                (
                  <React.Fragment key={index+product.id+product.name}>
                    <ListItem key={index+product.id+product.name} divider >
                      {productElement(product)}
                    </ListItem>
                 </React.Fragment>
                )
              )
            )
          }
        </>
      )
    }

    
    function productElement(product) {
        return (
            <Grid container style={{ padding: "0px" }}>
                <Grid container item xs={12} >
                    < Grid item xs={3} md={3} lg={2} style={{ padding: "4px" }} container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        justifyContent="center">

                        <img
                          width={100}
                          height={100}
                          src={product.image}
                          alt={product.name}
                          // src={URL.createObjectURL(props.selectedSalesOrder.image)}
                          loading="lazy"
                          onError={(event) => {
                              event.currentTarget.onerror = null; // prevents looping
                              event.currentTarget.src="https://transacti.tradynamics.com/img/no-image-available.jpg";
                          }}
                      />
                    </Grid>
                    <Grid item xs={9} md={10} lg={10}>
                        <Grid
                            container
                            direction="column"
                            justifyContent="space-between"
                            alignItems="stretch">
                            <Grid item >
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.brand}</Box>
                                <Box style={{ fontWeight: 600, fontSize: "14px" }}>{product.name}</Box>

                            </Grid>
                         
                            <Grid item style={{ fontWeight: 600, fontSize: "14px", color: "green" }}>Total inventory : {product.lot_number_and_expiration.length > 0 ? Number(product.inventory_in_smallest_uom ).toLocaleString(undefined, {minimumFractionDigits:0,maximumFractionDigits:0}): 0} {product.smallest_uom}</Grid>
                            {productLotNumberAndExpiration(product)}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
    
    useEffect(() => {
      if(!loadProducts){
        return
      }
      setAppBarWidth(elementRef.current.getBoundingClientRect().width);
      fetchProducts(searchProductTerm.name); 
    },[loadProducts,searchProductTerm.name]); // eslint-disable-line react-hooks/exhaustive-deps
     
    useEffect(()=>{
      function fetchAutoSuggestProducts(searchString){
        const ourRequest = axios.CancelToken.source() // <-- 1st step
        const loadProducts = async () => {
          setAutoCompleteSearchOptionMessage("Searching")
  
          const options = {
            method: 'POST',
            url: '/TransactiSellerProducts/getProductsForAutoSuggest.json',
            cancelToken: ourRequest.token,
            data: objectToFormData({company_id:companyId,search_term:searchString})
          }
          const response = await axios(options)
            .then(res => {
              
              const products = res.data.products
              if(products.length <= 0){
                setAutoCompleteSearchOptionMessage("No record found.")
                setAutoSuggestProducts([])
              }else{
                setAutoSuggestProducts(products)
              }
              
            }).catch(error => {
      
              
      
            })
        }
        loadProducts()
         
        return () => {
            console.log("test data")
          if (ourRequest !== undefined) {
              console.log("cancelled")
              ourRequest.cancel() //
            }
        }
      }
  
      if(searchProductTerm == null){
        
        fetchAutoSuggestProducts("")
      }else{
        fetchAutoSuggestProducts(searchProductTerm.name)
      }
    },[searchProductTerm]) 

    

      function fetchProducts(searchTerm){
        setIsLoading(true)
        const options = {
          method: 'POST',
          url: '/TransactiSellerProducts/getTransactiLiteProductsWithInventory.json',
          data: objectToFormData({search_term:searchTerm,page_number:pageNumber})
        }

         axios(options)
           .then(res => {
    
            setIsLoading(false)
            setLoadProducts(false)
    
             const isSuccess = res.data.response.is_success
             if(!isSuccess){
               alert("Error encounter")
             }
             
             console.log(res);
             const productsFromServer = res.data.response.Products
             const inventoryViewingSetting = res.data.respoInventoryViewingSetting
             setHasMoreProductToLoad(productsFromServer.length > 0)
             setProducts(products.concat(productsFromServer))  
             setInventoryViewingSetting(inventoryViewingSetting)
            
           }).catch(error => {
            alert(error)
            setIsLoading(false)
           })
      }

    const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      
    return formData;
    }, new FormData());

    function messageDialog(){
        return(
         
          <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
             {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{
                setShowMessageDialog(false)
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )
    }

    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar} ref={elementRef}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={props.handleDrawerToggle}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        Inventory
                </Typography>
                </Toolbar>
            </AppBar>
            {search()}
            {productLists()}
            <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
              {loadProducts ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
            </AppBar>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}> {messageDialog()}</ThemeProvider>
            </StyledEngineProvider>

        </div>
    );

}